import { ToastContainer, Slide } from "react-toastify";

/**
 * Single, app-wide toast container (KHAN-96).
 *
 * It is mounted once in index.js so every screen can call `toast.*()`, also
 * the ones outside the dashboard (login/register, join flows, reading view,
 * book creator). Do not mount another <ToastContainer> anywhere else: each
 * extra container renders every toast again (BUG-035).
 */
const AppToastContainer = () => (
  <ToastContainer
    position="top-right"
    autoClose={3000}
    limit={3}
    transition={Slide}
    theme="colored"
    hideProgressBar={false}
    newestOnTop={true}
    closeOnClick={true}
    pauseOnHover={true}
    draggable={false}
  />
);

export default AppToastContainer;
